import { doc, getDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { db } from '../firebase';

export default function Contact({userRef, listing}) {
   const [landlord, setLandlord] = useState(null);
   const [message, setMessage] = useState("");
    useEffect(()=>{
    async function getLandLord(){
     const docRef = doc(db, "users", userRef);
     const docSnap = await getDoc(docRef);
     if(docSnap.exists()){
      setLandlord(docSnap.data())
     }else{
        toast.error("Could not get landlord data");
     }
    }
    getLandLord();
    },[userRef]);
    function onChange(e){
     setMessage(e.target.value);
    }
  return (
    <>{landlord !== null && (
        <div className='flex flex-col w-full'>
            <p>Contact {landlord.name} for {listing.name.toLowerCase()}
            </p>
            <div className='mt-3 mb-6'>
                <textarea name="message" id="message" rows={2} 
                value={message} onChange={onChange} placeholder={`Write message for ${landlord.name} and attach your number to be contacted on...`} className='w-full px-4 py-2 text-xl 
                text-gray-700 bg-white border border-gray-300 rounded transition 
                duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-[#09848B]'>
                </textarea>
            </div>
            <a href={`mailto:${landlord.email}?Subject=${listing.name}&body=${message}`}>
                <button className='px-7 py-3 bg-[#09848B] text-white rounded text-sm uppercase 
                shadow-md hover:bg-[#9B870C] hover:shadow-lg focus:bg-[#9B800C] focus:shadow-lg 
                active:bg-[#9B870C] active:shadow-lg transition duration-150 ease-in-out w-full text-center mb-6' 
                type='button'>Send Message</button>
            </a>
        </div>
    )}</>
  )
}
